import React, { type ReactNode } from "react";

import * as styles from "@/features/betslip/components/parts/BetRow.module.scss";

type BetRowProps = {
  icon: ReactNode;
  name: ReactNode;
  market?: ReactNode;
  rightSlot?: ReactNode;
  testId?: string;
};

// A single selection/leg row: icon, name + market, optional right control. The
// connector line is drawn by a surrounding BetSpine, not here — the icon slot
// only lifts itself above that line (see BetRow.module.scss).
export const BetRow = ({
  icon,
  name,
  market,
  rightSlot,
  testId,
}: BetRowProps) => (
  <div className={styles.row} data-testid={testId}>
    <div className={styles.iconSlot}>{icon}</div>
    <div className={styles.body}>
      <div className={styles.name}>{name}</div>
      {market ? <div className={styles.market}>{market}</div> : null}
    </div>
    {rightSlot ? <div className={styles.rightSlot}>{rightSlot}</div> : null}
  </div>
);
